import { ChangeDetectionStrategy, Component } from '@angular/core';
import { castArray } from '@sama/micro-dash';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-rejection-reasons',
  templateUrl: './rejection-reasons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RejectionReasonsComponent {
  singleReason$: Observable<string | undefined>;
  multipleReasons$: Observable<string[] | undefined>;

  constructor(store: TaskWorkspaceStore) {
    const displayableReasons$ = getDisplayableReasons$(store);
    this.singleReason$ = displayableReasons$.pipe(
      map((reasons) => (reasons.length === 1 ? reasons[0] : undefined)),
    );
    this.multipleReasons$ = displayableReasons$.pipe(
      map((reasons) => (reasons.length > 1 ? reasons : undefined)),
    );
  }
}

function getDisplayableReasons$(store: TaskWorkspaceStore) {
  return combineLatest(
    store('project')('display_reject_reason').$,
    store('task')('rej_reason').$,
  ).pipe(
    map(([displayReason, reason]) =>
      displayReason && reason ? castArray(reason) : [],
    ),
  );
}
